var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Integration",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.461,
    height: 32,
    viewBox: "0 0 32.461 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M25.136,69.78a.747.747,0,0,0-1.164-.023c-3.584,4.3-7.512,7.794-12.742,6.9a.748.748,0,0,0-.857.561l0,.016a.749.749,0,0,0,.6.913,11.209,11.209,0,0,0,1.911.167c5.016,0,8.878-3.539,12.255-7.582a.748.748,0,0,0,.015-.936Z",
    transform: "translate(-10.348 -51.829)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M67.691,25.122a.747.747,0,0,0,1.173,0c3.484-4.454,6.9-8.309,11.177-7.785l-3.274,3.274a.787.787,0,0,0-.073,1.053.759.759,0,0,0,.579.272.744.744,0,0,0,.532-.224l4.656-4.656a.756.756,0,0,0,0-1.071l-4.623-4.627a.787.787,0,0,0-1.062-.069.759.759,0,0,0-.039,1.107l3.425,3.428c-5.022-.6-8.855,3.721-12.486,8.36a.749.749,0,0,0,0,.926Z",
    transform: "translate(-50.223 -11.113)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M42.592,49.858,37.936,45.2a.756.756,0,1,0-1.069,1.069l3.3,3.305c-4.707.578-8.369-4.149-12.227-9.137C23.5,34.683,18.47,28.185,10.973,29.481a.75.75,0,0,0-.6.914l0,.016a.748.748,0,0,0,.857.56c6.6-1.131,11.131,4.725,15.515,10.393,3.729,4.822,7.566,9.785,12.613,9.785a7.886,7.886,0,0,0,.93-.061l-3.428,3.428a.756.756,0,1,0,1.069,1.069l4.656-4.659a.756.756,0,0,0,0-1.07Z",
    transform: "translate(-10.353 -23.808)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/integration-icon.651817dcb144219518afb984d7ee78eb.svg";
export { ForwardRef as ReactComponent };